/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteGuardrailsResponse = {
  object: "guardrails_settings";
  /**
   * Whether a policy row was deleted
   */
  deleted: boolean;
  /**
   * Team the deleted policy targeted; null for the org-wide policy
   */
  teamId: string | null;
};

/** @internal */
export const DeleteGuardrailsResponse$inboundSchema: z.ZodType<
  DeleteGuardrailsResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("guardrails_settings"),
  deleted: z.boolean(),
  team_id: z.nullable(z.string()),
}).transform((v) => {
  return remap$(v, {
    "team_id": "teamId",
  });
});
/** @internal */
export type DeleteGuardrailsResponse$Outbound = {
  object: "guardrails_settings";
  deleted: boolean;
  team_id: string | null;
};

/** @internal */
export const DeleteGuardrailsResponse$outboundSchema: z.ZodType<
  DeleteGuardrailsResponse$Outbound,
  z.ZodTypeDef,
  DeleteGuardrailsResponse
> = z.object({
  object: z.literal("guardrails_settings"),
  deleted: z.boolean(),
  teamId: z.nullable(z.string()),
}).transform((v) => {
  return remap$(v, {
    teamId: "team_id",
  });
});

export function deleteGuardrailsResponseToJSON(
  deleteGuardrailsResponse: DeleteGuardrailsResponse,
): string {
  return JSON.stringify(
    DeleteGuardrailsResponse$outboundSchema.parse(deleteGuardrailsResponse),
  );
}
export function deleteGuardrailsResponseFromJSON(
  jsonString: string,
): SafeParseResult<DeleteGuardrailsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteGuardrailsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteGuardrailsResponse' from JSON`,
  );
}
